import $ from 'jquery'
import store_config from '@/store/mods/parametres/config'

export default {
    name: 'login',
    components: {},
    props: [],
    data() {
        return {
            status: null,
            loginData: {
                email: '',
                password: ''
            },
            loading: false,

            showPassword: false,
            is_forgotten_pwd: false,

            fg_email: '',
            fg_new_password: '',
            fg_confirm_password: '',
            fg_code: '',
            err_msg: '',
            is_confirm: false,
            is_new_pwd: false
        }
    },
    computed: {

    },
    mounted() {
        console.log(this.$router.history.current.name)
    },
    methods: {
        loginProcess: function() {
            this.loading = true
            let err = 0

            if (this.loginData.email == '') {
                $('.err-msg-1').fadeIn(500)
                err++
                this.$refs.email.focus();
            } else if (this.loginData.password == '') {
                $('.err-msg-2').fadeIn(500)
                err++
                this.$refs.pwd.focus();
            }

            if (err == 0) {
                this.$store.dispatch('login', this.loginData).then(
                    (response) => {
                        let role = response.user.roles
                        
                        // check if the logged user has the right rights
                        let access = false;
                        for (let index = 0; index < role.length; index++) {
                            
                            if (
                                role[index].nom == "ROLE_COMPTABLE" || role[index].nom == "ROLE_ADMINISTRATEUR" || 
                                role[index].nom == "ROLE_CAISSIERE" || role[index].nom == "ROLE_TRESORERIE" || 
                                role[index].nom == "ROLE_ACCUEIL"
                            ) {
                                access = true
                                break;
                            } else {
                                access = false
                            }
                        }

                        if (access) { //he's allowed to pass
                            this.$router.push({ path: '/' });
                        } else { //NOT allowed
                            this.status = 403
                        }

                        this.loading = false;
                    }, error => {
                        console.log(error)
                        this.loading = false
                        this.status = error.response.status
                    }
                ).catch(
                    error => {
                        this.loading = false
                        this.status = error.response.status
                    }
                )
            } else {
                this.loading = false;
            }
        }, 

        clearError() {
            this.err_msg = '' 
            for(let i = 1; i < 3; i++) {
                $('.err-msg-'+i).fadeOut(500)
                this.status = ''
            }
        },

        onConfirm() {
            this.err_msg = ''
        },

        confirmer() {
            this.is_confirm = true
        },

        resetPassword(selector) {
            this.err_msg = ''
            if (this.fg_email == '') {
                this.err_msg = "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe."
                return
            }

            let confirm = document.getElementById(selector);
            if (confirm.checked == false) {
                this.err_msg = "Veuillez confirmer la réinitialisation du mot de passe."
                return
            }

            console.log("> ",this.fg_email);
            const data = {
                email: this.fg_email
            }
            this.loading = true
            store_config.setResetPwdCode(data).then((response) =>  {
                if (response.success) {
                    this.successToast(response.message)
                    confirm.checked = false
                    this.is_new_pwd = true
                } else {
                    this.err_msg = response.message
                }
                this.loading = false
            }).catch(() => {
                this.err_msg = "Une erreur s'est produite lors de la réinitialisation du mot de passe. Merci de réessayer plus tard."
                this.loading = false
            })
        },

        changePassword() {
            this.err_msg = ''
            if (this.fg_code == '') {
                this.err_msg = "Veuillez saisir votre code de réinitialisation."
                return
            }

            if (this.fg_new_password == '') {
                this.err_msg = "Veuillez saisir votre nouveau mot de passe."
                return
            }

            if (this.fg_confirm_password == '') {
                this.err_msg = "Veuillez confirmer votre nouveau mot de passe."
                return
            }

            if (this.fg_new_password != this.fg_confirm_password) {
                this.err_msg = "Les mots de passe saisis ne sont pas identiques."
                return
            }

            const data = {
                email: this.fg_email,
                reset_code: this.fg_code,
                new_password: this.fg_new_password
            }
            this.loading = true
            store_config.changePassword(data).then((response) =>  {
                if (response.success) {
                    this.successToast(response.message)
                    this.is_new_pwd = false
                    this.is_forgotten_pwd = false
                } else {
                    this.err_msg = response.message
                }
                this.loading = false
            }).catch(() => {
                this.err_msg = "Une erreur s'est produite lors du changement de mot de passe. Merci de réessayer plus tard."
                this.loading = false
            })
        }
    }
}